import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateBonusConfiguration } from './updateBonusConfiguration'
import { BonusConfigurationQueryInput } from './types'
import { BonusConfigurationModel } from '@/app/models/timesheet/bonusConfigurationModel'

export function useBonusConfigurationMutation(
  props: BonusConfigurationQueryInput & {
    onSuccess?: () => void
    onError?: (error: unknown) => void
  },
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: Partial<BonusConfigurationModel>) => {
      const { data } = await updateBonusConfiguration({
        companyId: props.companyId,
        payload: {
          ...props.payload,
          bonusConfiguration: payload,
        },
      })
      return data
    },

    onError: (error) => {
      // @TODO handle error properly
      // show notification to user
      // @TODO display notification
      console.error('Error useBonusConfigurationMutation:', error)
      if (props.onError) props.onError(error)
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [
        'bonus-configuration',
        props.companyId,
        props.payload.companyId,
        props.payload.driverId,
        props.payload.month,
        props.payload.year,
      ] })
      if (props.onSuccess) props.onSuccess()
    },
  })
}
